import React from "react";
import clsx from "clsx";
import moment from "moment";
import {getFontAwesomeIconForType} from "../../../../utils/FileUtils";
import "./_drawer-file-tile.scss";

// gdy plik nie ma jeszcze typu z API, ikone da sie wybrac po rozszerzeniu -
// getFontAwesomeIconForType czyta typ MIME, wiec podsuwamy mu jego kawalek
const EXTENSION_TYPES = {
    pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/msword",
    xls: "ms-excel",
    xlsx: "spreadsheetml",
    csv: "ms-excel",
    ppt: "ms-powerpoint",
    pptx: "presentationml",
    zip: "zip",
    rar: "zip",
    "7z": "zip",
    mp4: "video",
    mov: "video",
    avi: "video",
    mkv: "video",
    mp3: "audio",
    wav: "audio",
    jpg: "image",
    jpeg: "image",
    png: "image",
    webp: "image",
    bmp: "image",
    gif: "image",
};

function getTypeFromExtension(extension) {
    if (!extension) return "";
    return EXTENSION_TYPES[extension.toLowerCase()] || "";
}

function getNameParts(name = "") {
    const split = name.split(".");
    if (split.length <= 1) return {baseName: name, extension: ""};
    return {
        baseName: split.slice(0, -1).join("."),
        extension: split[split.length - 1],
    };
}

/**
 * Wspolny kafelek pliku dla drawera zadania - miniatura na calej powierzchni,
 * nazwa i data na dole, akcje w prawym gornym rogu.
 *
 * Na desktopie akcje pojawiaja sie na hover, na mobilce (compact) siedza pod
 * kropkami, ktore otwieraja Menu - o tym decyduje komponent nadrzedny, bo to
 * on wie, ktory wariant renderuje.
 */
export default function DrawerFileTile({
    name,
    type,
    thumbnail,
    date,
    marked = false,
    compact = false,
    loading = false,
    onClick,
    actions,
    progress,
    className,
    containerRef,
    onContextMenu,
}) {
    const {baseName, extension} = getNameParts(name);

    return (
        <div
            ref={containerRef}
            className={clsx("drawer-file-tile", className, {
                "has-thumbnail": !!thumbnail,
                marked,
                compact,
            })}
            onClick={onClick}
            onContextMenu={onContextMenu}>
            <div className="drawer-file-tile-media">
                {thumbnail ? (
                    <img src={thumbnail} alt={name} />
                ) : loading ? (
                    <div className="drawer-file-tile-placeholder" />
                ) : (
                    <i
                        className={`fa-solid ${getFontAwesomeIconForType(
                            type || getTypeFromExtension(extension)
                        )}`}
                    />
                )}
            </div>
            {progress && (
                <div className="drawer-file-tile-progress">{progress}</div>
            )}
            <div className="drawer-file-tile-info">
                <span
                    className={clsx("drawer-file-tile-name", {marked})}
                    title={name}>
                    <span>{baseName}</span>
                    {!!extension && (
                        <span className="drawer-file-tile-ext">
                            .{extension}
                        </span>
                    )}
                </span>
                {!!date && (
                    <span className="drawer-file-tile-date">
                        {moment(date).calendar()}
                    </span>
                )}
            </div>
            {!!actions && (
                <div
                    className="drawer-file-tile-actions"
                    onClick={(e) => e.stopPropagation()}>
                    {actions}
                </div>
            )}
        </div>
    );
}
